<div>
  <mat-drawer-container
    [hasBackdrop]="false"
    autosize
    style="height: calc(100vh - 50px); width: 100%"
  >
    <mat-drawer
      [disableClose]="true"
      #drawer
      mode="side"
      opened
      style="display: block"
    >
      <!-- <mat-toolbar>
                <mat-toolbar-row> -->
      <div class="heading">Categories</div>
      <div *ngIf="!noCategories">
        <div class="input-group-sm mt-2 input-group col-12">
          <input
            class="form-control"
            type="search"
            (keyup)="applyFilterOnCategories($event)"
            (search)="applyFilterOnCategories($event)"
            placeholder="Filter"
          />
        </div>
      </div>

      <div class="m-2 text-center" *ngIf="noCategories">
        No Categories to view
      </div>

      <!-- </mat-toolbar-row>
            </mat-toolbar> -->
      <mat-tree
        *ngIf="!noCategories"
        [dataSource]="categoryTreeData"
        [treeControl]="treeControl"
      >
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node
          *matTreeNodeDef="let node"
          matTreeNodePadding
          [matTreeNodePaddingIndent]="20"
        >
          <!-- use a disabled button to provide padding for tree leaf -->
          <button mat-icon-button style="min-width: 16px;" disabled></button>
          <button
            mat-button
            [ngClass]="node.id === category ? 'bold-text' : 'normal-text'"
            (click)="selectCategory(node.name, node.id)"
          >
            {{ node.name }}
          </button>
        </mat-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <mat-tree-node
          *matTreeNodeDef="let node; when: hasChild"
          matTreeNodePadding
          [matTreeNodePaddingIndent]="20"
        >
          <button
            mat-icon-button
            matTreeNodeToggle
            [attr.aria-label]="'toggle ' + node.name"
            style="min-width: 16px;"
          >
            <mat-icon class="mat-icon-rtl-mirror">
              {{
                treeControl.isExpanded(node) ? "expand_more" : "chevron_right"
              }}
            </mat-icon>
          </button>
          <button
            class="mat-tree-child-node"
            mat-button
            [ngClass]="node.id === category ? 'bold-text' : 'normal-text'"
            (click)="selectCategory(node.name, node.id)"
          >
            {{ node.name }}
          </button>
        </mat-tree-node>
      </mat-tree>
    </mat-drawer>

    <mat-drawer-content>
      <div *ngIf="!openUpload">
        <div class="container-fluid">
          <div class="row">
            <!-- Document List -->
            <div class="col mt-1" *ngIf="!hideDocList">
              <div class="card p-2" *ngIf="!selectedCategory">
                <div class="card-body p-2">
                  <strong>Please select a category</strong><br />
                  1. To view the documents associated with it.<br />
                  2. To upload a document to the selected category.<br />
                </div>
              </div>
              <div *ngIf="selectedCategory">
                <div class="row" *ngIf="!noDocuments">
                  <mat-paginator
                        #myPaginator
                        [pageSizeOptions]="[50, 100]"
                        [pageSize]="50" [pageIndex]="pageIndex" [length]="totalDocumentCount" (page)="selectPage($event)"
                        class="custom-paginator"
                        showFirstLastButtons
                      >
                      </mat-paginator>
                </div>
                <div class="Tabletitle">
                  Document List for Category - {{ categoryName }} ({{
                    totalDocumentCount | number
                  }})                  
                </div>
                <div *ngIf="appError" class="alert alert-info">
                  {{ appError }}
                </div>
                <div class="filtercontainer row">
                  <!-- MCRTX Changes -->
                  <!-- <span *ngIf="selection.selected.length>0">
                                        <button class="uploadbutton" style="margin-bottom: 2px;" mat-raised-button (click)="exportDocuments()"> <mat-icon>cloud_download</mat-icon> Export
                                            </button>
                                    </span> -->
                  <div
                    class="col-4 mt-2 mb-2"
                    role="group"
                    aria-label="First group"
                  >
                    <button
                      mat-stroked-button
                      class="btn btn-small"
                      title="refresh"
                      (click)="refresh()"
                      style="float: right"
                    >
                      <mat-icon title="refresh">refresh</mat-icon>
                    </button>
                  </div>
                  <div class="input-group-sm mt-2 mb-2 input-group col-4">
                    <input
                      class="form-control"
                      type="search"
                      [(ngModel)]="filterInput"
                      (keyup)="applyFilter()"
                      (search)="applyFilter()"
                      placeholder="Filter"
                    />
                  </div>                  
                </div>

                <div *ngIf="noDocuments" class="card">
                  <div class="card-body">
                    {{ categoryName }} has no documents to display.
                  </div>
                </div>
              </div>

              <div
                class="xAxis-scroll-auto mat-elevation-z8"
                *ngIf="docResultsList"
              >
                <div class="row" style="margin-bottom: 1em;">
                  <div class="col-2">
                      <button mat-button [matMenuTriggerFor]="menu">
                          Show/Hide Columns
                          <mat-menu #menu="matMenu">
                            <span class="table-config-menu-label">Edit Columns</span>
                            <div class="table-config-menu-options">
                              <mat-checkbox 
                                *ngFor="let cd of selectedFormDisplayList; let i = index"
                                (click)="$event.stopPropagation()"
                                [(ngModel)]="cd.visible">
                                {{cd.name}}
                              </mat-checkbox>
                              <button (click)="applyShowHideColumns()">Apply</button>
                            </div>
                        </mat-menu>
                      </button>
                  </div>           
                </div>
                <table
                  mat-table
                  [dataSource]="docResultsList"
                  matSortActive="create_date"
                  matSortDirection="desc"
                  matSort
                  aria-describedby="document-list"
                >
                  <!-- dynamic columns -->
                  <ng-container *ngFor="let column of selectedFormDisplayList">
                    <ng-container  *ngIf = "column.visible && column.type == 'original'"                    
                      matColumnDef="{{ column.name }}"
                    >
                      <th
                        id="{{ column.name }}"
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                      >
                        {{ column.name  }}
                      </th>
                      <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element.documentId, drawer)" >
                        {{ element[column.value] }}
                      </td>
                    </ng-container>
                    <ng-container  *ngIf = "column.visible && column.type == 'properties' && column.data_type == 'object'"                    
                      matColumnDef="{{ column.name }}"
                    >
                      <th
                        id="{{ column.name }}"
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                      >
                        {{ column.name  }}
                      </th>
                      <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element.documentId, drawer)" >
                        {{ element.metadata.properties[column.value] | json}}
                      </td>
                    </ng-container>
                    <ng-container  *ngIf = "column.visible && column.type == 'properties' && column.data_type != 'object'"                    
                      matColumnDef="{{ column.name }}"
                    >
                      <th
                        id="{{ column.name }}"
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                      >
                        {{ column.name  }}
                      </th>
                      <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element.documentId, drawer)" >
                        {{ element.metadata.properties[column.value] }}
                      </td>
                    </ng-container>
                    <ng-container  *ngIf = "column.visible && column.type == 'system'"                    
                      matColumnDef="{{ column.name }}"
                    >
                      <th
                        id="{{ column.name }}"
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                      >
                        {{ column.name  }}
                      </th>
                      <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element.documentId, drawer)" >
                        {{ element.metadata.system[column.value] }}
                      </td>
                    </ng-container>
                  </ng-container>
                  <!-- end dynamic columns-->
                  <ng-container matColumnDef="duplicates">
                    <th id="duplicates" mat-header-cell *matHeaderCellDef>Duplicates </th>
                    <td mat-cell *matCellDef="let element">
                        <a href="javascript:void(0)" (click)="clickDuplicate(element)">Show/Hide</a>
                        <div *ngIf="duplicateSubList && showDuplicateLink && element.documentId == selectedDoc">
                            <table mat-table [dataSource]="duplicateSubList" aria-describedby="capture-table" matSort>                                   
                                <ng-container matColumnDef="documentName">
                                    <th id="documentName" mat-header-cell *matHeaderCellDef> File Name </th>
                                    <td mat-cell *matCellDef="let element">
                                        <a href="javascript:void(0)" (click)="getDocDetails($event, element.documentId, drawer)">{{element.documentName}}</a>
                                    </td>
                                </ng-container>
                        
                                <ng-container matColumnDef="createDate">
                                    <th id="createDate" mat-header-cell *matHeaderCellDef> Uploaded date </th>
                                    <td mat-cell *matCellDef="let element"> {{element.createDate | date }} </td>
                                </ng-container>
                                <ng-container matColumnDef="createdBy">
                                    <th id="createdBy" mat-header-cell *matHeaderCellDef> Uploaded By </th>
                                    <td mat-cell *matCellDef="let element"> {{element.createdBy }} </td>
                                </ng-container>
                                 <!-- dynamic columns -->
                                <ng-container *ngFor="let column of duplicatedColumns">
                                  <ng-container
                                    *ngIf="column.indexOf('display_') === 0"
                                    matColumnDef="{{ column }}"
                                  >
                                    <th
                                      id="{{ column | stripDisplay }}"
                                      mat-header-cell
                                      *matHeaderCellDef
                                    >
                                      {{ column | stripDisplay }}
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                      {{ element[column] }}
                                    </td>
                                  </ng-container>
                                </ng-container>
                                <!-- end dynamic columns-->                                                                
                                <tr mat-header-row *matHeaderRowDef="duplicatedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: duplicatedColumns;"
                                    class="element-row" [class.selected-row]="selectedRow === row"
                                    (click)="selectedRow = selectedRow === row ? null : row"
                                    title="Select Document">
                                </tr>
                            </table>
                        </div>
                        
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="documentCols"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: documentCols"                    
                    class="element-row"
                    [class.selected-row]="selectedRow === row"
                    (click)="selectedRow = selectedRow === row ? null : row"
                  ></tr>
                </table>                
              </div>              
            </div>
            <!-- End Document List -->
            <!-- File Properties -->
            <div class="col" *ngIf="selectedDoc && hideDocList">
              <app-display-search-doc
                [selectedDocument]="selectedDoc"
                [categoryPermissions]="categoryPermissions"
                [searchResultsList]="docResultsList"
                [showSearchDocList]="false"
                (hideDocList)="onHideDocList($event)"
              >
                <!-- (hideDocListWithCategoryChange)="onHideDocListWithCategoryChange($event.param1, $event.param2, $event.param3)" -->
              </app-display-search-doc>
            </div>
            <!-- End File Properties -->
          </div>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
